import { ApolloProvider } from '@apollo/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { createApolloClient } from 'data/connection/client.connection';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

import { darkTheme, lightTheme } from './constants/theme';
import { ThemeContextProvider } from './ThemeContextProvider';
import { AuthProvider } from './contexts/AuthContext';

import { NewVersionBanner } from 'components/NewVersionBanner';
import { router } from 'pages/router';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getThemePreference } from 'data/connection/storage';

export const apolloClient = createApolloClient();

function getTheme() {
    const themeFromStorage = getThemePreference();

    switch (themeFromStorage) {
        case 'dark':
            return darkTheme;
        case 'light':
        default:
            return lightTheme;
    }
}

function App() {
    useEffect(() => {
        if (window.__TOTENV__.ENV !== 'production') {
            const favicon = document.getElementById('favicon');

            if (favicon) {
                favicon.setAttribute('href', '/favicon-preprod.svg');
            }
        }
    });

    return (
        <GoogleOAuthProvider clientId={window.__TOTENV__.GOOGLE_CLIENT_ID}>
            <ThemeContextProvider defaultTheme={getTheme()}>
                <ApolloProvider client={apolloClient}>
                    <HelmetProvider>
                        <ToastContainer position="bottom-right" />
                        <NewVersionBanner />
                        <AuthProvider>
                            <RouterProvider router={router} />
                        </AuthProvider>
                    </HelmetProvider>
                </ApolloProvider>
            </ThemeContextProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
